import { RowItem, RowItemPicker } from 'components/RowItemPicker'
import { PermissionsGate } from 'features/permissions'
import React from 'react'
import styled from 'styled-components'
import { ThemeMode, useGeckoTheme } from 'styles/GeckoTheme'
import { PERMISSION_GECKO_INTERNAL_MEMBER } from 'types'

const StyledContainer = styled.div`
  padding: 0.25rem 0.25rem 0.75rem 1rem;
  margin-bottom: -0.5rem;
  width: 100%;
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
  align-items: center;
  overflow-x: scroll;
`

const StyledRowItemPicker = styled(RowItemPicker)`
  background-color: ${({ theme }) => theme.forecast.background3};
  border-radius: 0.25rem;
`

export const ThemeModeToggle: React.FC = () => {
  const { themeMode, setThemeMode } = useGeckoTheme()

  const basicThemes = [ThemeMode.Dark, ThemeMode.Light, ThemeMode.Zinc]
  const internalThemes = [
    ThemeMode.Freedom,
    ThemeMode.Spooky,
    ThemeMode.HotDog,
    ThemeMode.Barbie,
    ThemeMode.Brat,
    ThemeMode.BratRemix,
  ]

  const handleThemeModeChange = (theme: ThemeMode): void => {
    setThemeMode(theme)
  }

  return (
    <StyledContainer>
      Theme
      <StyledRowItemPicker height='32px'>
        {basicThemes.map((theme) => (
          <RowItem
            key={theme}
            $isActive={theme === themeMode}
            onClick={() => handleThemeModeChange(theme)}>
            {theme}
          </RowItem>
        ))}
        <PermissionsGate requires={[PERMISSION_GECKO_INTERNAL_MEMBER]}>
          {internalThemes.map((theme) => (
            <RowItem
              key={theme}
              $isActive={theme === themeMode}
              onClick={() => handleThemeModeChange(theme)}>
              {theme}
            </RowItem>
          ))}
        </PermissionsGate>
      </StyledRowItemPicker>
    </StyledContainer>
  )
}
